export default "__VITE_ASSET__CKomYnkZ__"